export type ApplicationType = 'backoffice' | 'app';

/**
 * This service is thought to provide components with an overview
 * of the current application and configuration.
 */
export abstract class AppConfigurationService {
  abstract getApp(): ApplicationType;
}
